var Const = (function() {
  var messages = {
    monthlyAnalyzeOverLimit: '保存できる分析結果が上限を超えています',
    monthlyAnalyzeCapacityOverLimit: '実行できる分析従量が上限を超えています',
    success: '成功した処理'
  };
  var Test = {};
  Test.getMessage = function(name) {
    return messages[name];
  };
  return Test;
})();
